import { useEffect, useState } from 'react';

// Corte único de "teléfono" para todo el portal. Debe coincidir con el
// @media de src/movil.css: si se cambia uno, se cambia el otro.
export const ANCHO_MOVIL = 768;
const CONSULTA = `(max-width: ${ANCHO_MOVIL}px)`;

const coincide = () =>
  typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(CONSULTA).matches;

// true mientras la pantalla mida 768px o menos. Escucha los cambios (girar el
// teléfono, achicar la ventana) para que el portal se reacomode sin recargar.
export default function useEsMovil() {
  const [esMovil, setEsMovil] = useState(coincide);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(CONSULTA);
    const alCambiar = () => setEsMovil(mq.matches);
    alCambiar();
    // Safari < 14 solo conoce addListener.
    if (mq.addEventListener) mq.addEventListener('change', alCambiar);
    else mq.addListener(alCambiar);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', alCambiar);
      else mq.removeListener(alCambiar);
    };
  }, []);

  return esMovil;
}
